/**
 * Variable names for Kakao Developers → Kakao Talk Message → Custom Template.
 *
 * Template layout (Stage 2):
 *   - Image URL variable:     #{image_url}
 *   - Sender line:            #{sender_line}   e.g. "Jun님이 카드를 보냈습니다"
 *   - Title:                  #{card_title}
 *   - Description:            #{short_hint}
 *   - Button / image / title links (Component Link): https://www.thehope.one/#{card_path}
 *   - Optional full URL arg: #{card_url}
 *
 * After creating the template, set REACT_APP_KAKAO_FAN_CARD_TEMPLATE_ID in .env
 */
export const FAN_CARD_KAKAO_TEMPLATE_VARS = {
    senderName: "sender_name",
    senderLine: "sender_line",
    cardTitle: "card_title",
    shortHint: "short_hint",
    cardUrl: "card_url",
    /** Path + query only — use in Kakao template when Web domain is fixed separately (no leading slash). */
    cardPath: "card_path",
    imageUrl: "image_url",
    buttonTitle: "button_title",
  } as const;
  
  export const FAN_CARD_KAKAO_DEFAULT_BUTTON_KO = "카드 열기";
  